import { computed } from 'vue';
import { ICustomProductButton } from '@/models/custom-products.interface';
import { CustomProductTypes } from '@studyportals/campaign-management-api-interface';
import { ModalCustomProductStates } from '@/models/modal/modal.enum';
import { IconClasses } from '@/models/icon-classes.enum';
import { LoadingStatuses } from '@/models/loading.interface';
import customProductPresenter from '@/presenters/custom-product-presenter';
import store from '@/store';

export default class AddCustomProductCode {

	public get customProductButtons(): ICustomProductButton[] {
		return Object.values(CustomProductTypes)
			.filter((type: CustomProductTypes) => type !== CustomProductTypes.FREE_VALUE)
			.map((type: CustomProductTypes) => {
				return {
					type,
					label: customProductPresenter.retrieveLabelOfType(type),
					icon: this.retrieveIconOfType(type)
				};
			});
	}

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusCustomProducts();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public selectCustomProductType(type: CustomProductTypes): void {
		store.mutations.setSelectedTypeForCustomProductCreation(type);
		this.showCustomProductModal();
	}

	private retrieveIconOfType(type: CustomProductTypes): IconClasses {
		switch (type) {
			case CustomProductTypes.ACT:
				return IconClasses.GRAPH;
			case CustomProductTypes.BANNER_DESIGN:
				return IconClasses.PALETTE;
			case CustomProductTypes.EMAIL:
				return IconClasses.ENVELOPE;
			case CustomProductTypes.LEADS:
				return IconClasses.FUNNEL;
			case CustomProductTypes.REMARKETING:
				return IconClasses.REDO;
			case CustomProductTypes.TIKTOK:
				return IconClasses.TIKTOK;
			case CustomProductTypes.OTHER:
				return IconClasses.ELLIPSIS;
			default:
				throw Error(`AddCustomProduct.retrieveIconOfType: invalid custom product type: ${type as string}`);
		}
	}

	private showCustomProductModal(): void {
		store.mutations.setModalCustomProductState(ModalCustomProductStates.ADD_PRODUCT);
	}
}
